import { EBookingStatus, EExamStatus } from '../enums'

export const CBookingStatusDes: any = {
  [EBookingStatus.Invalid]: 'invalid',
  [EBookingStatus.Created]: 'create-new',
  [EBookingStatus.Confirmed]: 'confirmed',
  [EBookingStatus.Canceled]: 'reject',
  [EBookingStatus.InProgress]: 'in-progressing',
  [EBookingStatus.Finished]: 'complete'
}

export const CExamStatusDes: any = {
  [EExamStatus.Waiting]: 'waiting-examination',
  [EExamStatus.InProgress]: 'being-examined',
  [EExamStatus.DataCollection]: 'data-collection',
  [EExamStatus.Finished]: 'examed',
  [EExamStatus.Canceled]: 'doctor-reject',
  [EExamStatus.Confirmed]: 'waiting-examination'
}
